module.exports = __webpack_public_path__ + "static/media/performance-testing.4938b901.svg";